import {getState} from '../slices/iotData';
import findMyDeviceStatuses from '../../consts/device/findMyDeviceStatuses';

const selectIotData = () => getState();

const selectIsConnectInProgress = (isHolder) => {
    const iotData = selectIotData();
    return isHolder ? iotData.isHolderConnectInProgress : iotData.isConnectInProgress;
};
const selectIsConnectedToCm = (isHolder) => {
    const iotData = selectIotData();
    return isHolder ? iotData.isHolderConnectedToCm : iotData.isConnectedToCm;
};
const selectIsUamWebSocketAlive = (isHolder) => {
    const iotData = selectIotData();
    return isHolder ? iotData.isHolderUamWebSocketAlive : iotData.isUamWebSocketAlive;
};
const selectIsUpdateSettingsInProgress = (isHolder) => {
    const iotData = selectIotData();
    return isHolder ? iotData.isHolderUpdateSettingsInProgress : iotData.isUpdateSettingsInProgress;
};
const selectIsFwuInProgress = () => {
    const iotData = selectIotData();

    return iotData.isFwuInProgress;
};
const selectIsResetDeviceInProgress = (isHolder) => {
    const iotData = selectIotData();
    return isHolder ? iotData.isHolderResetDeviceInProgress : iotData.isResetDeviceInProgress;
};
const selectIsFindMyDeviceInProgress = () => {
    const iotData = selectIotData();

    return (
        iotData.findMyDeviceStatus === findMyDeviceStatuses.START ||
        iotData.findMyDeviceStatus === findMyDeviceStatuses.STOP
    );
};
const selectIsAutoCleanInProgress = () => {
    const iotData = selectIotData();

    return iotData.isAutoCleanInProgress;
};

const selectDeviceData = () => selectIotData()?.chargerData?.device;
const selectHolderData = () => selectIotData()?.holderData?.device;

const selectIsDeviceInSblMode = () => selectDeviceData()?.isSBLMode;
const selectIsHolderInSblMode = () => selectHolderData()?.isSBLMode;

export {
    selectIsConnectInProgress,
    selectIsConnectedToCm,
    selectIsUamWebSocketAlive,
    selectIsUpdateSettingsInProgress,
    selectIsFindMyDeviceInProgress,
    selectIsAutoCleanInProgress,
    selectIsResetDeviceInProgress,
    selectIsDeviceInSblMode,
    selectIsHolderInSblMode,
    selectIsFwuInProgress,
    selectDeviceData,
    selectHolderData,
};
